import { render, staticRenderFns } from "./formReadGroupLabelInput.vue?vue&type=template&id=b48360b2&"
import script from "./formReadGroupLabelInput.vue?vue&type=script&lang=js&"
export * from "./formReadGroupLabelInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b48360b2')) {
      api.createRecord('b48360b2', component.options)
    } else {
      api.reload('b48360b2', component.options)
    }
    module.hot.accept("./formReadGroupLabelInput.vue?vue&type=template&id=b48360b2&", function () {
      api.rerender('b48360b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/formReadGroupLabelInput.vue"
export default component.exports